/** What the rest of the site needs to know about this game without loading it. Its name and
 * pitch are translated: `games.stack.*` in src/locales/common.ts. */
export const SKYLINE_STACKER = {
  /** Key for the stored best score and the game's strings. */
  id: "stack",
} as const;
